import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M25 3a.5.5 0 0 1 .5.5V7H35v30H4V7h9.5V3.5a.5.5 0 0 1 1 0V7h10V3.5A.5.5 0 0 1 25 3ZM13.5 8v3.5a.5.5 0 0 0 1 0V8h10v3.5a.5.5 0 0 0 1 0V8H34v28H5V8h8.5Zm5 17.29c0-1.138-.628-1.9-1.347-2.341.659-.462 1.199-1.205 1.199-2.278 0-1.008-.439-1.821-1.16-2.37-.707-.537-1.658-.801-2.685-.801-1.684 0-2.963.75-3.761 1.73l.774.632c.623-.762 1.623-1.362 2.987-1.362.868 0 1.59.224 2.08.598.478.363.765.885.765 1.573 0 1.042-.817 1.647-1.597 1.829H13.47v1h2.394c.76.141 1.635.745 1.635 1.79 0 .632-.26 1.166-.743 1.552-.492.394-1.246.658-2.25.658-1.534 0-2.6-.645-3.1-1.344l-.813.583c.713.995 2.103 1.761 3.913 1.761 1.172 0 2.164-.308 2.875-.877A2.924 2.924 0 0 0 18.5 25.29Zm7-7.79c-1.467 0-2.49.783-3.123 1.855-.62 1.053-.877 2.397-.877 3.638 0 1.234.257 2.58.877 3.638.63 1.077 1.653 1.869 3.123 1.869 1.464 0 2.486-.793 3.118-1.869.62-1.056.882-2.403.882-3.638 0-1.242-.261-2.586-.883-3.638-.633-1.072-1.656-1.855-3.117-1.855Zm-3 5.493c0-1.125.237-2.278.739-3.13.49-.832 1.217-1.363 2.261-1.363 1.037 0 1.764.53 2.256 1.364.504.852.744 2.005.744 3.129 0 1.116-.24 2.273-.744 3.132-.44.749-1.221 1.375-2.256 1.375-1.042 0-1.77-.536-2.26-1.375-.503-.858-.74-2.015-.74-3.132Z",
  fill: "#828282"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }